module.exports = __webpack_public_path__ + "static/media/Taped-it.3ed4e79a.png";